import { IonButton, IonIcon, IonSkeletonText, IonText, useIonRouter } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { CHOSEN_CORE_VALUES_LIMIT } from "@/lib/constants";
import { useReflection } from "@/lib/hooks/useReflection";
import { arrowRightIcon } from "@/lib/icons/@heroicons/react/16/solid";
import { queryOptions_coreValuesChosen } from "@/lib/query/functions/core-values/chosen";
import { useMyProgression } from "@/lib/query/functions/user/progression";
import { ProgressBar } from "../Global/ProgressBar";

export function ReflectionWidget() {
	const { t } = useTranslation();
	const { service: reflectionService, isLoading: isReflectionLoading } = useReflection();
	const router = useIonRouter();
	const [myProgression] = useMyProgression();
	const { data: coreValues, isLoading: isCoreValuesLoading } = useQuery(
		queryOptions_coreValuesChosen(),
	);

	if (isReflectionLoading || isCoreValuesLoading) {
		return <IonSkeletonText animated className="h-42 rounded-3xl" />;
	}

	const coreValuesCount = coreValues?.length ?? 0;
	const all = reflectionService.getProgress();

	if (coreValuesCount >= CHOSEN_CORE_VALUES_LIMIT || all.current >= all.total) {
		return <></>;
	}

	return (
		<div className="bg-brown-100 flex flex-col gap-2 rounded-3xl p-4">
			<IonText className="text-brown-700 text-2xl font-bold">
				{t("widgets.reflection.title")}
			</IonText>
			<IonText className="text-brown-600">{t("widgets.reflection.description")}</IonText>
			<div className="border-brown-200 rounded-2xl border-2 p-3">
				<IonText className="text-brown-700 text-sm font-semibold">
					{t("widgets.reflection.progress", { count: all.current, target: all.total })}
				</IonText>
				<ProgressBar value={all.current / all.total} />
			</div>
			<IonButton
				onClick={() => router.push(reflectionService.router.question())}
				className="ion-py-2.5 ion-rounded-lg min-h-10"
			>
				{myProgression.reflection === "COMPLETED_ALL"
					? t("widgets.reflection.action-finished")
					: t("widgets.reflection.action")}
				<IonIcon slot="end" icon={arrowRightIcon} className="ml-2 size-5 opacity-60" />
			</IonButton>
		</div>
	);
}
